import { onBeforeUnmount, onMounted, ref } from '@vue/composition-api'

const breakpoints = {
  xl: 1440,
  lg: 1367,
  md: 1024,
  sm: 576,
  xs: 0
}

const breakpointsState = () => ({
  xl: false,
  lg: false,
  md: false,
  sm: false,
  xs: false,
  smAndDown: false
})

export function useDisplay() {
  function getDisplay(width) {
    for (const [size, breakpoint] of Object.entries(breakpoints)) {
      const br = breakpointsState()
      if (width < breakpoints['md']) {
        br['smAndDown'] = true
      }
      if (width >= breakpoint) {
        br[size] = true
      }
      return br
    }
    return 'xl'
  }

  const display = ref(getDisplay(window.innerWidth))

  function handleResize() {
    display.value = getDisplay(window.innerWidth)
  }

  onMounted(() => {
    window.addEventListener('resize', handleResize)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize)
  })

  return display
}
